import {
  type FormConfig,
  type FormArrayConfig,
  type FormGroupConfig,
  type CheckboxConfig,
  type SelectConfig
} from '@common';
import { getHeightmapLayerTypesForDownload } from '../utils';

export const PARCELS_TABLE_HEADERS = [
  {
    grid: { cols: 1 }
  },
  {
    grid: { cols: 7 },
    label: 'heightmap.modal.layersDownloadModal.label.name'
  },
  {
    grid: { cols: 4 },
    label: 'heightmap.modal.layersDownloadModal.label.area'
  }
];

export const PARCELS_FORM_CONFIG: FormConfig = {
  name: 'tableForm',
  settings: {
    autoInitialize: false
  },
  attributes: {
    density: 'compact',
    color: 'primary',
    variant: 'outlined'
  },
  children: [
    {
      component: 'formArray',
      settings: {
        pageable: true
      },
      name: 'parcels'
    } as FormArrayConfig,
    {
      component: 'checkbox',
      name: 'selectAll',
      attributes: {
        label: 'heightmap.modal.layersDownloadModal.label.selectAll',
        hideDetails: true,
        class: 'mb-4'
      },
      settings: {
        grid: { cols: 12, md: 12 },
        needTranslate: true
      }
    } as CheckboxConfig,
    {
      component: 'select',
      name: 'layerType',
      attributes: {
        label: 'heightmap.label.layerType',
        hideDetails: true,
        multiple: true,
        itemTitle: 'label',
        itemValue: 'value'
      },
      settings: {
        needTranslate: true,
        needItemTranslate: true,
        items: getHeightmapLayerTypesForDownload(),
        grid: { cols: 12, md: 12 }
      },
      validators: [
        {
          validator: 'required'
        }
      ]
    } as SelectConfig
  ]
};

export const createHeightmapLayersDownloadFormGroup = (
  parcelId: string,
  index: number,
  selected: boolean
): FormGroupConfig => ({
  name: `${index}`,
  component: 'formGroup',
  settings: {
    defaultValue: { id: parcelId }
  },
  attributes: {
    hideDetails: true
  },
  children: [
    {
      component: 'checkbox',
      name: 'selected',
      settings: {
        grid: { cols: 1 },
        defaultValue: selected
      },
      attributes: {
        hideDetails: true
      }
    } as CheckboxConfig,
    {
      component: 'display',
      name: 'name',
      settings: {
        needTranslate: true,
        grid: { cols: 7 }
      },
      attributes: {
        hideDetails: true
      }
    },
    {
      component: 'display',
      name: 'area',
      settings: {
        needTranslate: true,
        grid: { cols: 4 }
      },
      attributes: {
        hideDetails: true,
        suffix: 'ha'
      }
    }
  ]
});
